// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import HoverMRRDescription from './HoverMRRDescription'
// JS Imports
import {
   //@ts-ignore
   formatFloatAsPercent,
   //@ts-ignore
   formatFloatAsCurrencySymbol,
} from '../../../common/helpers.mjs'
import Description from '../../ui-helper-elements/Description'
import HoverDifferenceDescription from './HoverDifferenceDescription'
// Asset Imports

export default function BenefitsAdministrationProductRow() {
   const state = useQuoteContext()
   const permissionsShowMRROnDifferenceQuotes =
      state.featurePermissions['ShowMRROnDifferenceQuotes']
   const ShowMRROnDifferenceQuotes =
      permissionsShowMRROnDifferenceQuotes.includes(state.user_role)

   if (state.product_list['benAdmin']?.NotInPricebook) {
      return <> </>
   }

   if (
      state.user_view == 'Internal' ||
      state.productBenefitsAdministrationEECount > 0 ||
      state.hasUSEmployees == true
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.product_list['benAdmin']['ProductName']} (
               {formatFloatAsCurrencySymbol(
                  state.product_list['benAdmin']['EmpListPrice'],
                  state.currencyObject,
               )}
               )
            </div>
            <div className='col-bhr2'>
               <input
                  className='form-control'
                  type='number'
                  value={
                     state.productBenefitsAdministrationEECount <= 0
                        ? ''
                        : state.productBenefitsAdministrationEECount.toString()
                  }
                  onChange={(e) =>
                     state.onProductBenefitsAdministrationEECountChange(
                        Number(e.target.value),
                     )
                  }
                  onBlur={() =>
                     state.onProductBenefitsAdministrationEECountChange(
                        Math.floor(state.productBenefitsAdministrationEECount),
                     )
                  }
                  min={0}
                  placeholder={'0'}
               />
            </div>
            <div className='col col-bhr-red'>
               {formatFloatAsPercent(
                  state.productBenefitsAdministrationMonthlyCosts
                     .volumeDiscountedPEPMPercent,
               )}
            </div>
            <div className='col col-bhr-red'>
               {state.hasUSEmployees == true || state.user_view == 'Internal'
                  ? formatFloatAsPercent(
                       state.productBenefitsAdministrationMonthlyCosts
                          .bundleDiscountedPEPMPercent,
                    )
                  : ''}
            </div>
            <div className='col'>
               {state.productBenefitsAdministrationMonthlyCosts
                  .discountedPEPMCost <=
               state.productBenefitsAdministrationMonthlyCosts.listPEPMCost
                  ? formatFloatAsCurrencySymbol(
                       state.productBenefitsAdministrationMonthlyCosts
                          .discountedPEPMCost,
                       state.currencyObject,
                    )
                  : ''}
            </div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.productBenefitsAdministrationMonthlyCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <HoverDifferenceDescription
                     previousPlan={
                        state.accountSnowflake.Ben_Admin_Rate_Plan__c
                     }
                     previousQuantity={
                        state.accountSnowflake.Billed_Ben_Admin__c
                     }
                     previousInvoicedAmount={
                        state.productBenefitsAdministrationMonthlyCosts
                           .previousTotalPriceUnconverted
                     }
                     previousStartDate={
                        state.accountSnowflake.Ben_Admin_Start_Date__c
                     }
                     previousCurrencyObject={state.currencyObjectPrevious}
                  >
                     <span className='hoverable'>
                        {formatFloatAsCurrencySymbol(
                           state.productBenefitsAdministrationMonthlyCosts
                              .previousTotalPrice,
                           state.currencyObject,
                        )}
                     </span>
                  </HoverDifferenceDescription>
                  {ShowMRROnDifferenceQuotes ? (
                     <HoverMRRDescription
                        listMRRTotal={
                           state.productBenefitsAdministrationMonthlyCosts
                              .listMRRTotal
                        }
                        previousMRRTotal={
                           state.productBenefitsAdministrationMonthlyCosts
                              .previousMRRTotal
                        }
                        MRRTotal={
                           state.productBenefitsAdministrationMonthlyCosts
                              .MRRTotal
                        }
                        MRRTotalUSD={
                           state.productBenefitsAdministrationMonthlyCosts
                              .MRRTotalUSD
                        }
                        currencyObjectCurrent={state.currencyObject}
                        currencyObjectUSD={state.currencyObjectUSD}
                     >
                        <span className='hoverable'>
                           {formatFloatAsCurrencySymbol(
                              state.productBenefitsAdministrationMonthlyCosts
                                 .totalPriceDifference,
                              state.currencyObject,
                           )}
                        </span>
                     </HoverMRRDescription>
                  ) : (
                     <span className='col'>
                        {formatFloatAsCurrencySymbol(
                           state.productBenefitsAdministrationMonthlyCosts
                              .totalPriceDifference,
                           state.currencyObject,
                        )}
                     </span>
                  )}
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
